<template>
  <div id="contenedor-main-contrato-ejecucion">
    <v-container fluid class="d-print-none">
      <v-card flat>
        <v-card-text>
          <titulo-tool-bar
          :titulo="getContrato.numero"
          :datos="getContrato"
          :fechas="getContratoFechas"
          regresar
          nombreRuta="ejecucion">
          </titulo-tool-bar>
          <opciones-tool-bar></opciones-tool-bar>
        </v-card-text>
      </v-card>
    </v-container>
    <v-container
      fluid>
      <router-view></router-view>
    </v-container>
  </div>
</template>

<script>
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import CONTRATO_FECHAS from '@/graphql/querys/administracion/contratos/fechas/contratoFechas.gql';
import TituloToolBar from './TituloToolBar.vue';
import OpcionesToolBar from './OpcionesToolBar.vue';

export default {
  name: 'MainContratoEjecucion',
  components: {
    TituloToolBar,
    OpcionesToolBar,
  },
  data() {
    return {};
  },
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
    contratoFechas: {
      query: CONTRATO_FECHAS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  computed: {
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
    getContratoFechas() {
      if (!this.contratoFechas) return [];
      return this.contratoFechas;
    },
  },
};
</script>

<style lang="scss">

</style>
